
import $ from 'jquery'

import { ApiModule } from '@api/src/ApiModule'

// An Api module for UI components
export class UI extends ApiModule {
  alert(txt) {
    alert(`TEST: "${txt}"`)
  }

  headerHeight() {
    // If these elements exist on the current page the will be added to the header height
    const selectors = ['.emailqueue-toolbar', '.app-header']
    let height = 0
    selectors.forEach((e) => {
      const $e = $(e)
      const h = $e.outerHeight()
      if (typeof h === 'number') height += h
    })
    return height
  }
}
